import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import { FEATURES } from 'collaboration-sidebar/constants/features';
import { convertEnabledFeatures } from '../utils';
import useFrameworkAppSettings from './useFrameworkAppSettings';
export default function useGetPropsFromFAS(t0) {
  "use memo";

  const $ = _c(29);
  const {
    appName,
    enabledFeatures
  } = t0;
  const {
    getCollaborationSidebarAppSetting,
    getCommentingAppSetting,
    loading
  } = useFrameworkAppSettings();
  let t1;
  bb0: {
    var _collaborationSidebar4, _collaborationSidebar5, _collaborationSidebar6, _collaborationSidebar7, _collaborationSidebar8, _collaborationSidebar9;
    let collaborationSidebarAppSettings;
    let objectTypeFromFAS;
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[0] !== appName || $[1] !== enabledFeatures || $[2] !== getCollaborationSidebarAppSetting || $[3] !== getCommentingAppSetting || $[4] !== loading) {
      var _collaborationSidebar, _getCommentingAppSett, _collaborationSidebar2, _collaborationSidebar3;
      collaborationSidebarAppSettings = getCollaborationSidebarAppSetting(appName);
      if (!collaborationSidebarAppSettings) {
        let t6;
        if ($[12] !== loading) {
          t6 = {
            loading,
            fasProps: undefined
          };
          $[12] = loading;
          $[13] = t6;
        } else {
          t6 = $[13];
        }
        t1 = t6;
        break bb0;
      }
      objectTypeFromFAS = (_collaborationSidebar = collaborationSidebarAppSettings.objectType) === null || _collaborationSidebar === void 0 ? void 0 : _collaborationSidebar.value;
      const isCommentingAppSettingsEnabled = Boolean(objectTypeFromFAS && ((_getCommentingAppSett = getCommentingAppSetting(objectTypeFromFAS)) === null || _getCommentingAppSett === void 0 ? void 0 : _getCommentingAppSett.enabled.value));
      let fasEnabledFeatures = collaborationSidebarAppSettings.enabledFeatures;
      if (!isCommentingAppSettingsEnabled && fasEnabledFeatures) {
        fasEnabledFeatures = Object.assign({}, fasEnabledFeatures, {
          value: fasEnabledFeatures.value.filter(_temp)
        });
      }
      const appHub = collaborationSidebarAppSettings.appHubs;
      t2 = appHub === null || appHub === void 0 ? void 0 : appHub.value;
      t3 = (_collaborationSidebar2 = collaborationSidebarAppSettings.dragAndDropConfig) === null || _collaborationSidebar2 === void 0 || (_collaborationSidebar2 = _collaborationSidebar2.value) === null || _collaborationSidebar2 === void 0 ? void 0 : _collaborationSidebar2.defaultSidebarPlacement;
      t4 = (_collaborationSidebar3 = collaborationSidebarAppSettings.dragAndDropConfig) === null || _collaborationSidebar3 === void 0 || (_collaborationSidebar3 = _collaborationSidebar3.value) === null || _collaborationSidebar3 === void 0 ? void 0 : _collaborationSidebar3.dragAndDropAreas;
      t5 = convertEnabledFeatures({
        appHub,
        fasEnabledFeatures,
        propEnabledFeatures: enabledFeatures
      });
      $[0] = appName;
      $[1] = enabledFeatures;
      $[2] = getCollaborationSidebarAppSetting;
      $[3] = getCommentingAppSetting;
      $[4] = loading;
      $[5] = collaborationSidebarAppSettings;
      $[6] = objectTypeFromFAS;
      $[7] = t2;
      $[8] = t3;
      $[9] = t4;
      $[10] = t5;
      $[11] = t1;
    } else {
      collaborationSidebarAppSettings = $[5];
      objectTypeFromFAS = $[6];
      t2 = $[7];
      t3 = $[8];
      t4 = $[9];
      t5 = $[10];
      t1 = $[11];
    }
    const t6 = (_collaborationSidebar4 = collaborationSidebarAppSettings.layoutConfig) === null || _collaborationSidebar4 === void 0 || (_collaborationSidebar4 = _collaborationSidebar4.value) === null || _collaborationSidebar4 === void 0 ? void 0 : _collaborationSidebar4.hideCommentModeAndToggle;
    const t7 = (_collaborationSidebar5 = collaborationSidebarAppSettings.layoutConfig) === null || _collaborationSidebar5 === void 0 || (_collaborationSidebar5 = _collaborationSidebar5.value) === null || _collaborationSidebar5 === void 0 ? void 0 : _collaborationSidebar5.isListingPage;
    const t8 = (_collaborationSidebar6 = collaborationSidebarAppSettings.layoutConfig) === null || _collaborationSidebar6 === void 0 || (_collaborationSidebar6 = _collaborationSidebar6.value) === null || _collaborationSidebar6 === void 0 ? void 0 : _collaborationSidebar6.isOverlay;
    const t9 = (_collaborationSidebar7 = collaborationSidebarAppSettings.layoutConfig) === null || _collaborationSidebar7 === void 0 || (_collaborationSidebar7 = _collaborationSidebar7.value) === null || _collaborationSidebar7 === void 0 ? void 0 : _collaborationSidebar7.scrollablePage;
    const t10 = (_collaborationSidebar8 = collaborationSidebarAppSettings.layoutConfig) === null || _collaborationSidebar8 === void 0 || (_collaborationSidebar8 = _collaborationSidebar8.value) === null || _collaborationSidebar8 === void 0 ? void 0 : _collaborationSidebar8.showSidebarHeader;
    const t11 = (_collaborationSidebar9 = collaborationSidebarAppSettings.layoutConfig) === null || _collaborationSidebar9 === void 0 || (_collaborationSidebar9 = _collaborationSidebar9.value) === null || _collaborationSidebar9 === void 0 ? void 0 : _collaborationSidebar9.withoutSidebar;
    let t12;
    if ($[14] !== objectTypeFromFAS || $[15] !== t10 || $[16] !== t11 || $[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8 || $[24] !== t9) {
      t12 = {
        appHub: t2,
        defaultSidebarPlacement: t3,
        dragAndDropAreas: t4,
        enabledFeatures: t5,
        hideCommentModeAndToggle: t6,
        isListingPage: t7,
        isOverlay: t8,
        objectType: objectTypeFromFAS,
        scrollablePage: t9,
        showSidebarHeader: t10,
        withoutSidebar: t11
      };
      $[14] = objectTypeFromFAS;
      $[15] = t10;
      $[16] = t11;
      $[17] = t2;
      $[18] = t3;
      $[19] = t4;
      $[20] = t5;
      $[21] = t6;
      $[22] = t7;
      $[23] = t8;
      $[24] = t9;
      $[25] = t12;
    } else {
      t12 = $[25];
    }
    const props = t12;
    let t13;
    if ($[26] !== loading || $[27] !== props) {
      t13 = {
        loading,
        fasProps: props
      };
      $[26] = loading;
      $[27] = props;
      $[28] = t13;
    } else {
      t13 = $[28];
    }
    t1 = t13;
  }
  return t1;
}
function _temp(feature) {
  return feature.name !== FEATURES.COMMENTS && feature.name !== FEATURES.DEEP_COMMENTING;
}